<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 32 32"
    :width="size"
    :height="size"
  >
    <path
      fill="currentColor"
      d="M30.372 18.189c-0.491-0.196-0.913-0.349-1.294-0.487-1.111-0.338-2.075-0.863-2.905-1.546l0.014 0.012-0.744-0.596h-1.887l-0.743 0.596c-0.815 0.671-1.779 1.196-2.832 1.519l-0.059 0.016c-0.382 0.139-0.804 0.291-1.294 0.487l-0.628 0.252v3.559c0 4.875 1.934 8.024 6.085 9.91l0.2 0.090h0.433l0.197-0.090c4.151-1.886 6.085-5.035 6.085-9.91v-3.559zM29 22c0 3.938-1.352 6.325-4.5 7.894-3.148-1.568-4.5-3.955-4.5-7.894v-2.196c0.214-0.080 0.414-0.152 0.603-0.221 1.33-0.419 2.483-1.052 3.479-1.869l-0.018 0.014 0.195-0.156h0.482l0.195 0.156c0.978 0.802 2.131 1.436 3.388 1.835l0.073 0.020c0.189 0.068 0.389 0.141 0.603 0.221zM22 8.268v2.731h1v2h2v-2c-0-0.736-0.398-1.379-0.991-1.726l-0.009-0.005v-1c0.001-0.043 0.001-0.093 0.001-0.143 0-4.095-3.024-7.485-6.96-8.057l-0.044-0.005c-0.297-0.039-0.641-0.062-0.99-0.062-4.416 0-7.996 3.579-7.999 7.994v0l-0.005 1.272c-0.604 0.352-1.003 0.996-1.003 1.733v2.44l1.112 1.045c0.013 0.096 0.028 0.191 0.045 0.286l0.071 0.392c0.291 1.592 0.912 3.002 1.792 4.212l-0.020-0.029v3.193l-8.088 2.52c-1.116 0.351-1.912 1.376-1.912 2.587 0 0.003 0 0.006 0 0.010v-0 4.346h16v-2h-14v-2.346c0-0.001 0-0.002 0-0.002 0-0.32 0.211-0.592 0.501-0.683l0.005-0.001 9.494-2.959v-2.863c0.777 0.546 1.673 0.997 2.633 1.307l0.071 0.020c0.348 0.108 0.748 0.173 1.163 0.181l0.004 0c0.039 0.001 0.077 0.001 0.116 0.001 0.035 0 0.070 0 0.105-0.002l-0.069-1.998-0.118-0.001c-0.224-0.003-0.439-0.038-0.642-0.101l0.016 0.004c-1.392-0.45-2.576-1.212-3.517-2.208l-0.004-0.004c-0.767-0.989-1.317-2.185-1.554-3.49l-0.008-0.050-0.071-0.391c-0.031-0.173-0.051-0.348-0.070-0.521l-0.041-0.365-1.014-0.953v-1.575h0.996l0.012-3.001c0-3.312 2.686-5.997 5.998-5.997 0.265 0 0.525 0.017 0.781 0.050l-0.030-0.003c2.984 0.453 5.245 3 5.245 6.075 0 0.051-0.001 0.101-0.002 0.152l0-0.008z"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgWarning',

  props: {
    size: {
      type: [Number, String],
      default: 32,
    },
  },
}
</script>
